import { render, staticRenderFns } from "./DynamicRegistersTest.vue?vue&type=template&id=2d781d76"
import script from "./DynamicRegistersTest.vue?vue&type=script&lang=js"
export * from "./DynamicRegistersTest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports